import dayjs from "dayjs";
import { FormikContextType, FormikErrors } from "formik/dist/types";
import React from "react";
import { Form } from "react-bootstrap";
import { useSelector } from "react-redux";
import { OrderCategory } from "../../../../api/endpoints/Order";
import { UserType } from "../../../../entities/User";
import { selectUser } from "../../../../store/selectors/UserSelectors";
import Footnote from "../../../RealtimeProductConfigurator/Footnote";
import FormError from "../../../RealtimeProductConfigurator/FormError";

interface Props<T> {
  formik: FormikContextType<T>;
  orderCategory: OrderCategory;
}

const helpText = (orderCategory: OrderCategory) => {
  switch (orderCategory) {
    case OrderCategory.ARCHIVE:
      return 'Please note that it can take up to a week to set up your access to MARS. Note that the start date will be the selected date starting from 00.00 UTC.';
    case OrderCategory.WEB:
      return 'Please note that it can take up to a week to set up your access to ecCharts. Note that the start date will be the selected date starting from 00.00 UTC.';
    default:
      return 'Please note that it takes up to 10 working days to set up the connection. The start date will be the selected date starting from 00.00 UTC.'
  }
}

const StartDateField = <T extends { start_date: string }>(props: Props<T>) => {
  const { formik, orderCategory } = props;
  const user = useSelector(selectUser);
  const errors = formik.errors as FormikErrors<{start_date: string}>;
  const minDate = user.type !== UserType.Admin ? dayjs().add(1, 'day').format('YYYY-MM-DD') : undefined;

  return (
    <Form.Group controlId="orderStartDate">
      <Form.Label>Start date</Form.Label>

      <Form.Control
        name="start_date"
        type="date"
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        value={formik.values.start_date}
        min={minDate}
        pattern="\d{4}-\d{2}-\d{2}"
        required
      />

      <FormError
        message={errors.start_date}
        when={formik.touched.start_date && Boolean(formik.errors.start_date)}
      />

      <Footnote
        text={helpText(orderCategory)}
      />
    </Form.Group>
  )
}

export default StartDateField;
